import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF7474",
      d: "M28 16.8c1.16 0 2.1.94 2.1 2.1v9.8a2.1 2.1 0 1 1-4.2 0v-9.8c0-1.16.94-2.1 2.1-2.1M30.8 36.4a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF7474",
      "fill-rule": "evenodd",
      d: "M47.6 28c0 10.825-8.775 19.6-19.6 19.6-10.824 0-19.6-8.775-19.6-19.6S17.176 8.4 28 8.4 47.6 17.175 47.6 28m-4.2 0c0 8.505-6.894 15.4-15.4 15.4S12.6 36.505 12.6 28 19.495 12.6 28 12.6 43.4 19.495 43.4 28",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }